// Generated from packages/shared/design-tokens/controls.json. Run pnpm tokens:build; do not edit.
export const CONTROL_PROFILES = {
    "app": {
        "small": {
            "height": "1.375rem",
            "fontSize": "0.75rem",
            "lineHeight": "1rem",
            "inset": "0.5rem",
            "iconSize": "0.75rem",
            "gap": "0.25rem"
        },
        "compact": {
            "height": "1.75rem",
            "fontSize": "0.75rem",
            "lineHeight": "1rem",
            "inset": "0.75rem",
            "iconSize": "0.875rem",
            "gap": "0.25rem"
        },
        "toolbar": {
            "height": "2.25rem",
            "fontSize": "0.75rem",
            "lineHeight": "1rem",
            "inset": "1rem",
            "iconSize": "0.875rem",
            "gap": "0.5rem"
        },
        "standard": {
            "height": "2.25rem",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem",
            "inset": "1rem",
            "iconSize": "0.875rem",
            "gap": "0.5rem"
        },
        "form": {
            "height": "2.5rem",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem",
            "inset": "1rem",
            "iconSize": "0.875rem",
            "gap": "0.5rem"
        },
        "onboarding-compact": {
            "height": "2.25rem",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem",
            "inset": "1rem",
            "iconSize": "0.875rem",
            "gap": "0.5rem"
        },
        "onboarding": {
            "height": "2.75rem",
            "fontSize": "1rem",
            "lineHeight": "1.5rem",
            "inset": "1.5rem",
            "iconSize": "1rem",
            "gap": "0.5rem"
        },
        "onboarding-prominent": {
            "height": "3.5rem",
            "fontSize": "1.125rem",
            "lineHeight": "1.75rem",
            "inset": "2rem",
            "iconSize": "1rem",
            "gap": "0.5rem"
        }
    },
    "extension": {
        "toolbar": {
            "height": "34px",
            "inset": "11px"
        }
    },
    "review": {
        "toolbar": {
            "height": "34px",
            "inset": "11px"
        }
    }
};
//# sourceMappingURL=controlProfiles.js.map